module.exports = __webpack_public_path__ + "img/no-result.6a9ccd04.png";